@defer (when user()) {
  <pp-user-card-small
    [onlyAvatar]="onlyAvatar()"
    [caption]="user()?.name + ' ' + user()?.surname"
    [label]="user()?.role | titlecase" />

  <pu-icon
    class="icon"
    size="16"
    (click)="editProfile()"
    iconName="user-edit" />
} @placeholder (minimum 1s) {
  <div class="loading">
    <div class="pp-shimmer avatar"></div>
    <div class="pp-shimmer main"></div>

    <div class="pp-shimmer icon"></div>
  </div>
}
